
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'rui-date',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
});
